import React, { lazy } from 'react';
import IconBugly from '@/assets/images/menu/icon-bugly.react.svg?react';
import { AuthNodes } from '@/config/app/auth';
import { getUserId } from '@/infrastructure/auth';
import { isWindows } from '@/infrastructure/product-info';
import { CapitalPlatform } from '@/infrastructure/utils/app';
import { NET_ERROR_TIPS } from '@/presentation/components/issue-list/components/tips';
import { MenuIcon } from '@/presentation/components/menu-icon';
import { IRouteConfig } from '../types';

export const netRoutes = (enable?: boolean): IRouteConfig[] => {
  const hideInMenu = enable === false || isWindows();

  return [
    {
      path: '/net',
      name: '网络',
      icon: <MenuIcon icon={IconBugly} fontSize={16} />,
      sort: 91,
      hideInMenu,
      platforms: getUserId() === '0018079908478381' ? [
        CapitalPlatform.Android,
        CapitalPlatform.IOS,
        CapitalPlatform.Mac,
        CapitalPlatform.VisionOS,
        CapitalPlatform.Flutter,
        CapitalPlatform.AppleTV,
      ] : [
        CapitalPlatform.Android,
        CapitalPlatform.IOS,
        CapitalPlatform.Mac,
        CapitalPlatform.VisionOS,
        CapitalPlatform.AppleTV,
        CapitalPlatform.Windows,
      ],
      disabledByFree: true,
      authName: AuthNodes.Net,
      routes: [
        {
          path: '/net/task/list',
          name: '网络探测',
          platforms: [
            CapitalPlatform.Android,
            CapitalPlatform.IOS,
            CapitalPlatform.Windows,
            CapitalPlatform.Mac,
          ],
          component: lazy(() => import('@/presentation/pages/net/task/list')),
        },
        {
          path: '/net/task/detail',
          name: '网络探测详情',
          component: lazy(() => import('@/presentation/pages/net/task/detail/index')),
          hideInMenu: true,
        },
        {
          path: '/net/http/detail',
          name: 'URL详情',
          component: lazy(() => import('@/presentation/pages/net/http/detail')),
          hideInMenu: true,
        },
        {
          path: '/net/http/domain/detail',
          name: '域名详情',
          component: lazy(() => import('@/presentation/pages/net/http/domain-detail')),
          hideInMenu: true,
        },
        {
          path: '/net/http',
          name: 'HTTP',
          platforms: [
            CapitalPlatform.Android,
            CapitalPlatform.IOS,
            CapitalPlatform.Mac,
            CapitalPlatform.VisionOS,
            CapitalPlatform.AppleTV,
          ],
          component: lazy(() => import('@/presentation/pages/net/http/list')),
        },
        {
          path: '/net/error/detail',
          name: '网络错误详情',
          platforms: [
            CapitalPlatform.Android,
            CapitalPlatform.IOS,
            CapitalPlatform.Mac,
            CapitalPlatform.VisionOS,
            CapitalPlatform.AppleTV,
          ],
          component: lazy(() => import('@/presentation/pages/net/http/detail')),
          hideInMenu: true,
        },
        {
          path: '/net/error',
          name: '网络错误',
          platforms: [
            CapitalPlatform.Android,
            CapitalPlatform.IOS,
            CapitalPlatform.Mac,
            CapitalPlatform.VisionOS,
            CapitalPlatform.AppleTV,
          ],
          component: lazy(() => import('@/presentation/pages/net/error/list')),
          tooltip: {
            tips: NET_ERROR_TIPS,
          },
        },
      ],
    },
  ];
};

export default netRoutes;
